export class FirmTransformer {
  static transform (obj) {
    let firm = {}
    firm.id = obj.id
    firm.council_id = obj.attributes.council_id
    firm.council_planner_group = obj.attributes.council_planner_group
    firm.name = obj.attributes.name
    // firm.activity_owner = obj.attributes.activity_owner
    firm.activity_owner = 0
    firm.contract_manager_id = obj.attributes.contract_manager
    firm.resource_coordinator_id = obj.attributes.resource_coordinator
    firm.created_at = obj.attributes.created_at // Can use a vue filter to format this wherever required
    firm.created_by = obj.attributes.created_by
    firm.archived_at = obj.attributes.archived_at
    firm.model_type = obj.attributes.model_type
    firm.managed_by = obj.attributes.managed_by

    return firm
  }

  static transformArray (array = []) {
    let data = []
    array.map(function (item) {
      data.push(FirmTransformer.transform(item))
    })
    return data
  }
}



// WEBPACK FOOTER //
// ./src/helpers/firms/firm.transformer.js